import {Component} from '@angular/core'
import {MatProgressSpinner} from '@angular/material/progress-spinner'

@Component({
  selector: 'spb-please-wait',
  imports: [MatProgressSpinner],
  templateUrl: './please-wait.component.html',
  styleUrl: './please-wait.component.scss'
})
export class PleaseWaitComponent {

}
